$(function(){
    if($('html').attr('lang') == "vi"){
        $('*').each(function(){
            if($(this).css('font-weight') == 300){ $(this).addClass('fontWeight400'); }
            if($(this).css('font-weight') == 500){ $(this).addClass('fontWeight600'); }
            if($(this).css('font-weight') == 800){ $(this).addClass('fontWeight700'); }
            if($(this).css('font-weight') == 900){ $(this).addClass('fontWeight700'); }
        });
    }
});